var exports = {
  "rq": "ActionMenu_Overlay__Ud2NS9",
  "az": "Box__uSRvJ8",
  "wy": "Box_1__PsnUj9",
};

module.exports = exports;
